import constants from '@/app-configs/constants'

export default [
  {
    path: '/communicationlogs',
    name: 'communicationlogs',
    component: () => import('@/views/communicationlogs/Logs.vue'),
    meta: {
      pageTitle: 'DEBTIA_COMMUNICATION_LOGS',
      breadcrumb: [
        {
          text: 'DEBTIA_COMMUNICATION_LOGS',
          active: true,
        },
      ],
      action: constants.action.permissionCommunicationLogsList,
      resource: constants.resource.templatelogs,
    },
  },
]
